export const lcvManualPrizeWinsConstants = {
    LCV_MANUAL_PRIZE_WINS_GET_REQUEST:"LCV_MANUAL_PRIZE_WINS_GET_REQUEST",
    LCV_MANUAL_PRIZE_WINS_GET_COMPLETE:"LCV_MANUAL_PRIZE_WINS_GET_COMPLETE",

    LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_REQUEST:"LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_REQUEST",
    LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_COMPLETE:"LCV_MANUAL_PRIZE_WINS_SET_FULFILMENT_COMPLETE",

    LCV_MANUAL_PRIZE_WINS_CLEAR_ACTION_RESULT:"LCV_MANUAL_PRIZE_WINS_CLEAR_ACTION_RESULT",
};
